export enum TypeIndexEnum {
  CRUD = 'CRUD',
  SELECT = 'SELECIONAR',
}
